<template>
  <Link class="flex items-center px-6 py-4" :href="`/clients/${client.id}/edit`" tabindex="-1">
    <div>
      <icon v-if="client.telegraph_chat_id || client.telegraph_chat" name="telegram" class="inline-block w-6 h-6" />
      <icon v-if="client.use_viber" name="viber" class="inline-block w-6 h-6" />
      <icon v-if="client.use_whatsapp" name="whatsapp" class="inline-block w-6 h-6" />
    </div>
  </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon.vue'

export default {
  components: {
    Icon,
    Link,
  },
  props: {
    client: Object,
  },
}
</script>
